var current = process.env.NODE_ENV

var appSettings

let urlParams = {};
(window.onpopstate = function () {
  let match
  let pl = /\+/g // Regex for replacing addition symbol with a space
  let search = /([^&=]+)=?([^&]*)/g
  let decode = function (s) {
    return decodeURIComponent(s.replace(pl, ' '))
  }
  let query = window.location.search.substring(1)

  // eslint-disable-next-line
  while (match = search.exec(query)) {
    if (decode(match[1]) in urlParams) {
      if (!Array.isArray(urlParams[decode(match[1])])) {
        urlParams[decode(match[1])] = [urlParams[decode(match[1])]]
      }
      urlParams[decode(match[1])].push(decode(match[2]))
    } else {
      urlParams[decode(match[1])] = decode(match[2])
    }
  }
})()

console.log(JSON.stringify(urlParams))

const hostname = urlParams.hostname || location.hostname

if (current === 'development') {
  appSettings = {
    // host: '192.168.15.2',
    // host: '172.16.0.18',
    host: hostname,
    mAutoLogin: false,
    // mHttpResponseTimeout: 1500,
    deviceHelper: true,
    pass: true
  }
} else {
  appSettings = {
    host: hostname
  }
}

export default appSettings



// WEBPACK FOOTER //
// ./src/settings.js